import { VertexEvent } from './VertexEvent';
export class LowestVertexEvent extends VertexEvent {
    constructor(p) {
        super(p);
    }
}
//# sourceMappingURL=LowestVertexEvent.js.map